// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from "react";
import PropTypes from "prop-types";
import { css } from "glamor";
import _ from "lodash";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import Link from "gatsby-link";
import { Button } from "antd";
import { OutLink, Image } from "@bodhi-project/components";
import { applyType, applyRhythm } from "@bodhi-project/typography";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import logoAlpha from "../assets/logo.png";
import twitterAlpha from "../assets/twitter.png";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { Fragment } = React;

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Desktop
const desktopNavStyle = css({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  "& h4.outline, .outline": {
    display: "none"
  },

  "& ul": {
    display: "flex",
    listStyle: "none",
    margin: 0,
    padding: 0,

    "& li": {
      margin: "0px 2em 0px 0px !important",
      alignItems: "center",

      "& a": {
        color: "#3f3f3f",
        borderBottom: "1.625px solid transparent !important",

        "&:hover": {
          color: "#3f3f3f",
          borderBottom: "1.625px solid #0000FF !important"
        },
        "&:visited": {
          textDecoration: "none"
        },
        "&:link": {
          textDecoration: "none"
        },
        "&:active": {
          textDecoration: "none"
        }
      }
    },

    "& .logo a:hover": {
      borderBottom: "1.625px solid transparent !important"
    },

    "& li:not(:first-child)": {
      lineHeight: "80px !important"
    }
  },

  "& .ant-btn-primary": _.merge(
    { ...applyType("ltb1ekq") },
    {
      fontWeight: 700,
      fontStyle: "italic",
      borderRadius: 0,
      backgroundColor: "#c32148",
      borderColor: "transparent",
      borderWidth: 0,
      color: "#FFFFFF !important",
      height: "auto",
      transition: "all 200ms cubic-bezier(0.78, 0.14, 0.15, 0.86)",
      "&:not(:last-child)": {
        marginRight: "20px"
      },
      borderBottom: "unset !important",

      "&:hover": {
        backgroundColor: "#d54177 !important",
        transform: "scale(1.1)",
        borderBottom: "unset !important"
      }
    },
    ...applyRhythm({ padding: "0.15X 1.15X" })
  )
});
const desktopNavStyleClass = desktopNavStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** DesktopNav */
class DesktopNav extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props);
  }

  /** standard renderer */
  render() {
    return (
      <nav className={desktopNavStyleClass}>
        <h4 className="nocontent outline">Desktop Navigation</h4>
        <div>
          <ul>
            <li className="logo">
              <Link
                to="/"
                style={{
                  display: "inline-block",
                  padding: 7,
                  background: "transparent"
                }}
              >
                <Image
                  src={logoAlpha}
                  alt="DMR Logo"
                  style={{
                    marginLeft: "12px",
                    height: "100%",
                    width: "100%",
                    border: "none",
                    background: "transparent"
                  }}
                />
              </Link>
            </li>
            <li>
              <Link to="/">
                <strong>{this.props.menu.title}</strong>
              </Link>
            </li>
            <Fragment>
              {_.map(this.props.menu.menu, menuItem => {
                const { title, link } = menuItem;
                return (
                  <li>
                    <Link to={link}>{title}</Link>
                  </li>
                );
              })}
            </Fragment>
          </ul>
        </div>
        <div style={{ paddingRight: "2em" }}>
          <Fragment>
            <OutLink
              className="ant-btn ant-btn-primary"
              to="https://www.digitalmediareserve.com"
            >
              LOGIN
            </OutLink>
          </Fragment>
          {/* <Fragment>
            <OutLink to="https://twitter.com/_docbrij">
              <Image
                src={twitterAlpha}
                alt="DMI Twitter"
                style={{
                  height: 45,
                  width: 45,
                  background: "transparent",
                  border: "none"
                }}
              />
            </OutLink>
          </Fragment> */}
        </div>
      </nav>
    );
  }
}

DesktopNav.propTypes = {
  menu: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

// --------------------------------------------------------------------- Export
export default DesktopNav;



// WEBPACK FOOTER //
// ./src/blocks/DesktopNav.jsx